import { render, staticRenderFns } from "./detalle_del_pedido.vue?vue&type=template&id=0cba9c9c&"
import script from "./detalle_del_pedido.vue?vue&type=script&lang=js&"
export * from "./detalle_del_pedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports